import type { LarryToHostMessage } from '@/lib/embed/host-messages'
import { logger } from '@/utils/logger'

/**
 * Posts a message to the parent window at each of `targetOrigins`. The browser delivers it only
 * when the parent's actual origin matches, so passing every allowed host origin reaches the real
 * host without ever sending to an unlisted one. Does nothing outside an iframe.
 */
export function postToParent(message: LarryToHostMessage, targetOrigins: readonly string[]): void {
  if (window.parent === window) return

  for (const origin of targetOrigins) {
    try {
      window.parent.postMessage(message, origin)
    } catch (err) {
      // A malformed origin in VITE_EMBED_PARENT_ORIGINS throws a SyntaxError; skip it.
      logger.warn(`Couldn't post "${message.action}" to embed host origin ${origin}:`, err)
    }
  }
}
